import { api } from '../../lib/api';
import type { PublicSiteContent } from '@pms/shared';

/** GET /v1/public/site-content — stored homepage stats (key→{value,label}).
 *  Unset keys are absent; callers overlay this onto SITE_CONTENT_DEFAULTS. */
export async function fetchSiteContent(): Promise<PublicSiteContent> {
  const { data } = await api.get<PublicSiteContent>('/site-content');
  return data;
}
